import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_019_sales_person_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Sales Agent",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            // {
            //     componentType: LayoutTypes.GROUP,
            //     style: {
            //         direction: FlexDirection.ROW,
            //         padding: 10,
            //     },
            //     childComponents: [
            //         {
            //             componentType: ComponentType.BUTTON,
            //             Label: "Back",
            //             style: {
            //                 backgroundColor: "#1f2937",
            //                 textColor: "#ffffff",
            //                 padding: 8,
            //                 borderRadius: 4,
            //             },
            //             onPressAction: "modulev1/sales_person_summary",
            //         },
            //     ],
            // },
            {
                componentType: LayoutTypes.FORM,
                Name: "external_sales_",
                TableName: "external_sales_employees",
                DisplayName: "Sales Agent",
                style: {
                    backgroundColor: "#ffffff",
                    padding: 16,
                    borderRadius: 8,
                },
                Fields: [
                    {
                        IncludeLabel: true,
                        Label: "Name",
                        BindValue: "txt_name",
                        Json_Attribute: "name",
                        componentType: ComponentType.TEXT_FIELD,
                        IsMandatory: true,
                        IsVerticalView: true,
                    },
                    {
                        IncludeLabel: true,
                        Label: "Group",
                        BindValue: "drp_group",
                        Json_Attribute: "group_id",
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        IsMandatory: true,
                        LookupName: "employee_group_sales_man",
                        IsVerticalView: true,
                    },
                    {
                        IncludeLabel: true,
                        Label: "Mobile",
                        BindValue: "txt_mobile",
                        Json_Attribute: "mobile",
                        componentType: ComponentType.TEXT_FIELD,
                        IsMandatory: true,
                        IsVerticalView: true,
                    },
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                // style: {
                //     direction: FlexDirection.ROW,
                //     gap: 10,
                //     padding: 10,
                // },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "Submit",
                        onPressAction: "save",
                        ActionType: "Add",
                        ScreenId: "19",
                        style: {
                            backgroundColor: "#2563eb",
                            textColor: "#ffffff",
                            padding: 12,
                            borderRadius: 8,
                        },
                    },
                    // {
                    //     componentType: ComponentType.BUTTON,
                    //     Label: "Cancel",
                    //     onPressAction: "modulev1/sales_person_summary",
                    //     style: {
                    //         backgroundColor: "#6b7280",
                    //         textColor: "#ffffff",
                    //         padding: 12,
                    //         borderRadius: 8,
                    //     },
                    // },
                ],
            },
        ],
    },
];
